export default __webpack_public_path__ + "assets/img/ddfd299a2e1fa1f389a830e6a2d2188b.svg";